import React, { useState, useEffect } from 'react';

type Question = {
    text: string;
    isTrue: boolean;
};

const questions: Question[] = [
    { text: 'Bananas grow on trees.', isTrue: false },
    { text: 'Sharks existed before trees.', isTrue: true },
    { text: 'Goldfish only have a 3-second memory.', isTrue: false },
    { text: 'Octopuses have three hearts.', isTrue: true },
    { text: 'Mount Everest is the closest point on Earth to the moon.', isTrue: false },
    { text: 'The Eiffel Tower can grow more than 6 inches taller in the summer heat.', isTrue: true },
    { text: 'Penguins live in the Arctic.', isTrue: false },
    { text: 'Humans have more than five senses.', isTrue: true },
    { text: 'A penny dropped from the top of the Empire State Building can kill someone.', isTrue: false },
    { text: 'The Great Wall of China is visible from space with the naked eye.', isTrue: false },
    { text: 'Sloths can hold their breath longer than dolphins.', isTrue: true },
    { text: 'Water conducts electricity.', isTrue: false },
    { text: 'Your stomach gets a new lining every 3 to 4 days.', isTrue: true },
    { text: 'Bulls hate the color red.', isTrue: false },
    { text: 'Tomatoes are fruits.', isTrue: true },
    { text: 'Carrots improve your night vision dramatically.', isTrue: false },
    { text: 'There are more stars in the universe than grains of sand on Earth.', isTrue: true },
    { text: 'Vikings wore horned helmets.', isTrue: false },
    { text: 'Butterflies can taste with their feet.', isTrue: true },
    { text: 'Sugar makes kids hyperactive.', isTrue: false },
    { text: 'Koalas have fingerprints that look like humans’ fingerprints.', isTrue: true },
    { text: 'Lightning never strikes the same place twice.', isTrue: false },
    { text: 'Some turtles can breathe through their butts.', isTrue: true },
    { text: 'Bats are blind.', isTrue: false },
    { text: 'Your fingernails keep growing after you die.', isTrue: false },
    { text: 'The inventor of the Pringles can was buried in one.', isTrue: true },
    { text: 'Dogs sweat by salivating.', isTrue: false },
    { text: 'Bananas are berries.', isTrue: true },
    { text: 'Ostriches bury their heads in the sand when scared.', isTrue: false },
    { text: 'The heart of a blue whale is as big as a car.', isTrue: true },
    { text: 'Chameleons change color to match their surroundings.', isTrue: false },
    { text: 'Venus is hotter than Mercury.', isTrue: true },
    { text: 'You swallow eight spiders a year while sleeping.', isTrue: false },
    { text: 'There are more fake flamingos in the world than real ones.', isTrue: true },
    { text: 'Lemmings commit mass suicide by running off cliffs.', isTrue: false },
    { text: 'The fingerprints of a koala are almost indistinguishable from those of a human.', isTrue: true },
    { text: 'George Washington had wooden teeth.', isTrue: false },
    { text: 'An octopus can taste with its arms.', isTrue: true },
    { text: 'Humans only use 10% of their brains.', isTrue: false },
    { text: 'A day on Venus is longer than a year on Venus.', isTrue: true },
    { text: 'Bulls are enraged by the color red.', isTrue: false },
    { text: 'Hot water can freeze faster than cold water.', isTrue: true },
    { text: 'Einstein failed math as a child.', isTrue: false },
    { text: 'A shrimp’s heart is in its head.', isTrue: true },
    { text: 'Camels store water in their humps.', isTrue: false },
    { text: 'Some metals explode on contact with water.', isTrue: true },
    { text: 'You can see the Great Wall of China from space with the naked eye.', isTrue: false },
    { text: 'Sharks don’t get cancer.', isTrue: false },
    { text: 'Bananas glow blue under UV light.', isTrue: true },
    { text: 'Venus rotates backwards compared to most planets.', isTrue: true },
    { text: 'Humans can see in complete darkness after their eyes adjust.', isTrue: false },
    { text: 'The longest hiccuping spree lasted over 60 years.', isTrue: true },
    { text: 'Bats always fly out of caves to the left.', isTrue: false },
    { text: 'There are more trees on Earth than stars in the Milky Way.', isTrue: true },
    { text: 'The tongue is the strongest muscle in the body.', isTrue: false },
    { text: 'Snails can sleep for years at a time.', isTrue: true },
    { text: 'Humans and giraffes have the same number of neck vertebrae.', isTrue: true },
    { text: 'The Amazon River is the longest river in the world.', isTrue: false },
    { text: 'The smell of freshly cut grass is actually a distress signal from the plant.', isTrue: true },
    { text: 'You can balance an egg on its end only during the equinox.', isTrue: false },
    { text: 'Cleopatra lived closer in time to the moon landing than to the construction of the Great Pyramid.', isTrue: true },
    { text: 'Alligators can’t climb trees.', isTrue: false },
    { text: 'Your blood is blue inside your body until it hits oxygen.', isTrue: false },
    { text: 'Humans share about 60% of their DNA with bananas.', isTrue: true },
    { text: 'Lightning always strikes the tallest object nearby.', isTrue: false },
    { text: 'Sea otters hold hands while sleeping to stay together.', isTrue: true },
    { text: 'Glass is a slow-moving liquid.', isTrue: false },
    { text: 'Some cats are allergic to humans.', isTrue: true },
    { text: 'Humans can’t cry in space.', isTrue: false },
    { text: 'The shortest war in history lasted only 38 minutes.', isTrue: true },
    { text: 'A duck’s quack doesn’t echo.', isTrue: false },
    { text: 'An astronaut’s height can increase by up to 2 inches in space.', isTrue: true },
    { text: 'The Great Wall of China is the longest man-made structure on Earth.', isTrue: true },
    { text: 'Your hair and nails continue growing after death.', isTrue: false },
    { text: 'Bees can recognize human faces.', isTrue: true },
    { text: 'The sun is yellow.', isTrue: false },
    { text: 'A single strand of spaghetti is called a spaghetto.', isTrue: true },
    { text: 'Earth is the only planet in our solar system with water.', isTrue: false },
    { text: 'Dolphins have unique names for each other.', isTrue: true },
    { text: 'Eating carrots turns your skin orange.', isTrue: true },
    { text: 'The human brain stops developing after age 18.', isTrue: false },
    { text: 'Some jellyfish are biologically immortal.', isTrue: true },
    { text: 'There’s no sound in space.', isTrue: true },
    { text: 'You can see the Great Wall of China from the Moon.', isTrue: false },
    { text: 'An octopus has blue blood.', isTrue: true },
    { text: 'Humans evolved directly from chimpanzees.', isTrue: false },
    { text: 'There’s a species of mushroom that can control ants like zombies.', isTrue: true },
    { text: 'Humans can survive for days without water.', isTrue: false },
    { text: 'Saturn could float in water if you had a big enough tub.', isTrue: true },
    { text: 'The Sahara Desert is the largest desert on Earth.', isTrue: false },
    { text: 'The moon has moonquakes.', isTrue: true },
    { text: 'Diamonds are made from compressed coal.', isTrue: false },
    { text: 'A group of flamingos is called a flamboyance.', isTrue: true },
    { text: 'You can’t see the Great Wall of China from low Earth orbit.', isTrue: true },
    { text: 'Sound travels faster in air than in water.', isTrue: false },
    { text: 'A blue whale’s tongue weighs as much as an elephant.', isTrue: true },
    { text: 'Napoleon was extremely short.', isTrue: false },
    { text: 'Honey never spoils.', isTrue: true },
    { text: 'Owls can rotate their heads 360 degrees.', isTrue: false },
    { text: 'The dot over a lowercase “i” is called a tittle.', isTrue: true },
    { text: 'Humans can’t taste food without saliva.', isTrue: true },
    { text: 'Bulls are colorblind.', isTrue: true },
    { text: 'Vikings discovered America before Columbus.', isTrue: true },
    { text: 'Your tongue has different sections for each taste.', isTrue: false },
    { text: 'There are more fake flamingos in the world than real ones.', isTrue: true },
    { text: 'Elephants are afraid of mice.', isTrue: false },
    { text: 'Rainbows can appear at night.', isTrue: true },
    { text: 'Chickens are too stupid to recognize individual humans.', isTrue: false },
    { text: 'You can’t hum while holding your nose closed.', isTrue: true },
    { text: 'The planet Uranus was almost named George.', isTrue: true },
    { text: 'Humans glow in the dark, but it’s too faint to see.', isTrue: true },
    { text: 'There are 52 states in the United States.', isTrue: false },
    { text: 'Spiders are insects.', isTrue: false },
    { text: 'Your brain is mostly made of fat.', isTrue: true },
    { text: 'The shortest commercial flight lasts under two minutes.', isTrue: true },
    { text: 'Coffee beans are actually beans.', isTrue: false },
    { text: 'The first computer bug was an actual insect.', isTrue: true },
    { text: 'Humans can’t burp in space.', isTrue: true },
    { text: 'Birds can’t move their eyes.', isTrue: true },
    { text: 'The color orange was named after the fruit.', isTrue: true },
    { text: 'A crocodile can’t stick its tongue out.', isTrue: true },
    { text: 'Dogs are completely colorblind.', isTrue: false },
    { text: 'Venus has more volcanoes than any other planet.', isTrue: true },
    { text: 'Water spirals down drains in opposite directions depending on the hemisphere.', isTrue: false },
    { text: 'A newborn baby has more bones than an adult.', isTrue: true },
    { text: 'Peanuts are nuts.', isTrue: false },
    { text: 'Jupiter has 95 moons.', isTrue: true },
    { text: 'The unicorn is the national animal of Scotland.', isTrue: true },
    { text: 'You can see the Milky Way from anywhere on Earth.', isTrue: false },
    { text: 'There’s enough DNA in your body to stretch from the Sun to Pluto and back.', isTrue: true },
    { text: 'A jellyfish is 95% water.', isTrue: true },
    { text: 'Dogs age seven human years for every real year.', isTrue: false },
    { text: 'Sharks don’t have bones.', isTrue: true },
    { text: 'Venus spins clockwise.', isTrue: true },
    { text: 'Pineapples grow underground.', isTrue: false },
    { text: 'The human nose can remember 50,000 different scents.', isTrue: true },
    { text: 'All snowflakes are unique.', isTrue: false },
    { text: 'The longest recorded flight of a chicken is 13 seconds.', isTrue: true },
    { text: 'A group of crows is called a murder.', isTrue: true },
    { text: 'There’s no gravity in space.', isTrue: false },
    { text: 'Your ears and nose never stop growing.', isTrue: true },
    { text: 'Bats are birds.', isTrue: false },
    { text: 'Humans share 98% of their DNA with chimpanzees.', isTrue: true },
    { text: 'China has only one time zone.', isTrue: true },
    { text: 'Tigers have striped skin, not just striped fur.', isTrue: true },
    { text: 'Fish can drown.', isTrue: true },
    { text: 'Tomatoes are vegetables.', isTrue: false },
    { text: 'The human heart is on the right side of the chest.', isTrue: false },
    { text: 'Butterflies once were called “flutterbies.”', isTrue: true },
    { text: 'Cats always land on their feet.', isTrue: false },
    { text: 'Honeybees can recognize human faces.', isTrue: true },
    { text: 'Sharks can live up to 500 years.', isTrue: false },
    { text: 'The Earth’s core is as hot as the surface of the Sun.', isTrue: true },
    { text: 'Penguins can fly.', isTrue: false },
    { text: 'The human body has more bacterial cells than human cells.', isTrue: true },
    { text: 'There are over 200 bones in the human body.', isTrue: false },
    { text: 'Octopuses have nine brains.', isTrue: false },
    { text: 'A sneeze can travel up to 100 miles per hour.', isTrue: true },
    { text: 'The first animated film was in 1905.', isTrue: false },
    { text: 'Sloths can turn their heads almost all the way around.', isTrue: true },
    { text: 'Cows have four stomachs.', isTrue: true },
    { text: 'Lightning never strikes water.', isTrue: false },
    { text: 'All penguins live in cold climates.', isTrue: false },
    { text: 'The fastest land animal is the cheetah.', isTrue: true },
    { text: 'A strawberry is a type of berry.', isTrue: false },
    { text: 'There’s a species of ant that can explode as a defense mechanism.', isTrue: true },
    { text: 'The sun is a planet.', isTrue: false },
    { text: 'Whales are mammals.', isTrue: true },
    { text: 'The tallest building in the world is in Dubai.', isTrue: true },
    { text: 'An ostrich’s eye is bigger than its brain.', isTrue: true },
    { text: 'The Moon is made of cheese.', isTrue: false },
    { text: 'Water boils at lower temperatures on mountains.', isTrue: true },
    { text: 'All spiders spin webs.', isTrue: false },
    { text: 'A group of owls is called a parliament.', isTrue: true },
    { text: 'Rats laugh when tickled.', isTrue: true },
    { text: 'Dinosaurs lived at the same time as humans.', isTrue: false },
    { text: 'A day on Mercury is longer than a year on Mercury.', isTrue: true },
    { text: 'Sharks are immune to all diseases.', isTrue: false },
    { text: 'Your stomach produces hydrochloric acid strong enough to dissolve metal.', isTrue: false },
    { text: 'A cockroach can live for several weeks without its head.', isTrue: true },
    { text: 'The human body has four lungs.', isTrue: false },
    { text: 'A jiffy is an actual unit of time.', isTrue: true },
    { text: 'The Great Wall of China can be seen from the Moon.', isTrue: false },
    { text: 'Bananas float in water.', isTrue: true },
    { text: 'Lightning can strike the same place twice.', isTrue: true },
    { text: 'The hummingbird is the only bird that can fly backwards.', isTrue: true },
    { text: 'Dogs can see in total darkness.', isTrue: false },
    { text: 'Saturn is the only planet that could float in water.', isTrue: true },
    { text: 'The tongue is the fastest healing part of the body.', isTrue: false },
    { text: 'A caterpillar has more legs than a spider.', isTrue: true },
    { text: 'Pineapples grow on trees.', isTrue: false },
    { text: 'Sloths can swim faster than humans.', isTrue: true },
    { text: 'An eagle’s eyesight is so sharp it can spot a rabbit from two miles away.', isTrue: true },
    { text: 'There’s no wind on the Moon.', isTrue: true },
    { text: 'The heart of a shrimp is located in its head.', isTrue: true },
    { text: 'Bats use echolocation to navigate in the dark.', isTrue: true },
    { text: 'The Amazon Rainforest produces 50% of the world’s oxygen.', isTrue: false },
    { text: 'Cows can climb stairs.', isTrue: false },
    { text: 'The human body glows in the dark, but it’s invisible to the naked eye.', isTrue: true },
    { text: 'Goldfish can recognize their owners.', isTrue: true },
    { text: 'The platypus is a mammal that lays eggs.', isTrue: true },
    { text: 'There are more bacteria in your mouth than people on Earth.', isTrue: true },
    { text: 'Watermelons grow on vines.', isTrue: true },
    { text: 'A giraffe’s neck has more bones than a human’s.', isTrue: false },
    { text: 'Sharks can smell one drop of blood in an Olympic-sized swimming pool.', isTrue: true },
    { text: 'Butterflies have teeth.', isTrue: false },
    { text: 'Some frogs can freeze completely and come back to life.', isTrue: true },
    { text: 'Humans can breathe and swallow at the same time.', isTrue: false },
    { text: 'The Moon has its own time zone.', isTrue: false }
];

var shuffledQuestions: Question[] = [...questions].sort(() => Math.random() - 0.5);

const QuizGame: React.FC = () => {
    const [questions, setQuestions] = useState<Question[]>(shuffledQuestions);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [lastQuestionRight, setLastQuestionRight] = useState<boolean | null>(null);
    const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
    const [questionsAnswered, setQuestionsAnswered] = useState(0);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else {
            setShowResult(true); // End the quiz when time runs out
        }
    }, [timeLeft]);

    const handleAnswer = (answer: boolean) => {
        const currentQuestion = questions[currentQuestionIndex];
        setQuestionsAnswered(questionsAnswered + 1);

         // Add 10 seconds for every 5 questions answered
        if (answer === currentQuestion.isTrue) {
            setScore(score + 1);
            setLastQuestionRight(true);
        } else {
            setScore(score - 1);
            setLastQuestionRight(false);
        }

        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            setShowResult(true);
        }
    };

    const resetGame = () => {
        setCurrentQuestionIndex(0);
        setScore(0);
        setShowResult(false);
        setTimeLeft(120); // Reset the timer
        setQuestions([...questions].sort(() => Math.random() - 0.5));
        setQuestionsAnswered(0);
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            {showResult ? (
                <div>
                    <h1>Quiz Finished!</h1>
                    <p>Your score: {score} / {questionsAnswered}</p>
                    <button onClick={resetGame}>Play Again</button>
                </div>
            ) : (
                <div>
                    <h1>True or False?</h1>
                    <div style={{ fontSize: '18px', marginBottom: '20px' }}>
                        Score: {score}
                    </div>
                    <div style={{ fontSize: '18px', marginBottom: '20px' }}>
                        Time Left: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, '0')}
                    </div>
                    <p>{questions[currentQuestionIndex].text}</p>
                    <button className="green-button" onClick={() => handleAnswer(true)}>True</button>
                    <button className="red-button" onClick={() => handleAnswer(false)}>False</button>
                    {lastQuestionRight !== null && (
                        <div style={{ marginTop: '20px', fontSize: '16px' }}>
                            {lastQuestionRight ? 'Correct!' : 'Wrong!'}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default QuizGame;